import React from 'react';
import { Skeleton } from './styled';
import { SkeletonProps } from './types';

export const ButtonSkeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '3rem',
  radius = 'large',
  ...props
}) => <Skeleton height={height} width={width} radius={radius} {...props} />;
